export const PAGE_PATHS = {
  LOGIN: '/login',
  MAINTENANCE: '/maintenance/default',
};